import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import Carousel from 'nuka-carousel'

import LazyLoad from '@components/common/Lazyload'

import {
  carouselContainer,
  arrowButtons,
  hiddenButtons,
  destroyButtons,
  chevronLeft,
  chevronRight,
  paddingDot,
  arrowWrapperLeft,
  arrowWrapperRight,
  LeftMasking,
} from './style'

class BannerCarousel extends Component {
  isMounted = false
  constructor(props) {
    super(props)
    this.state = {
      viewportWidth: 0,
      show: false,
    }
  }

  componentDidMount() {
    this.isMounted = true
    if (window && this.rootCarouselRef) {
      this.updateWindowDimensions()
      window.addEventListener('resize', this.updateWindowDimensions)
      setTimeout(() => {
        this.updateWindowDimensions()
        this.adjustSlideHeight(this.rootCarouselRef)
      }, 2000)
    }
  }

  componentWillUnmount() {
    this.isMounted = false
  }

  componentDidUpdate(prevProps) {
    // this.adjustSlideHeight(this.rootCarouselRef);
    if (this.props.children && prevProps.children && this.props.children.length != prevProps.children.length) {
      setTimeout(() => {
        this.adjustSlideHeight(this.rootCarouselRef)
      }, 1000)
    }
  }

  updateWindowDimensions = () => {
    if (this.isMounted) {
      this.setState({ viewportWidth: window.innerWidth, show: true })
    }
  }

  handleAfterSlide = slideIndex => {
    const carouselRef = this.rootCarouselRef

    if (carouselRef && this.props.afterSlideCallback) {
      this.props.afterSlideCallback(carouselRef)
    }
  }

  adjustSlideHeight = c => {
    if (c) {
      if (c.onResize) c.onResize()
      c.frame.style.minHeight = `${c.state.slideHeight}px`
      if (c.state.slideHeight && this.props.carouselHeightCallback) {
        this.props.carouselHeightCallback(c.state.slideHeight)
      }
      // if (c.frame.firstChild.offsetHeight <= c.state.slideHeight) {
      //   c.frame.firstChild.style.minHeight = `${c.state.slideHeight}px`
      // }
    }
  }

  static propTypes = {
    title: PropTypes.string,
    sliderCoin: PropTypes.bool,
    dragging: PropTypes.bool,
    wrap: PropTypes.bool,
    slidesToShow: PropTypes.number,
  }

  render() {
    const { viewportWidth, show } = this.state,
      isMobile = viewportWidth <= 640

    const { hasChevronIndicator } = this.props

    const isIpad = /iPad/.test(navigator.userAgent)

    const isDefaultChevron = this.props.transitionMode !== 'scroll3d' && hasChevronIndicator
    return (
      <Carousel
        ref={c => (this.rootCarouselRef = c) /** used to tracked if carousel exist or has been loaded */}
        style={{
          opacity: show ? 1 : 0,
        }}
        autoGenerateStyleTag={
          false
        } /** IMPORTANT NOTE: set to false to prevent custom styling injected by NukaCarousel library */
        autoplayInterval={5000}
        autoplay={this.props.autoplay}
        cellAlign={this.props.cellAlign}
        cellSpacing={this.props.cellSpacing}
        className={`${carouselContainer} ${this.props.className}`}
        disableEdgeSwiping={true}
        dragging={this.props.dragging}
        frameOverflow={this.props.frameOverflow}
        framePadding={this.props.framePadding}
        // heightMode={'max'}
        initialSlideHeight={this.props.initialSlideHeight}
        initialSlideWidth={this.props.initialSlideWidth}
        opacityScale={this.props.opacityScale || 0.65}
        slideOffset={this.props.slideOffset}
        slideWidth={this.props.slideWidth}
        slidesToScroll={this.props.slidesToScroll}
        slidesToShow={this.props.slidesToShow}
        transitionMode={this.props.transitionMode}
        width={this.props.width}
        withoutControls={this.props.withoutControls}
        wrapAround={this.props.wrap}
        zoomScale={this.props.zoomScale || 1}
        afterSlide={this.handleAfterSlide}
        renderBottomCenterControls={({ slideCount, currentSlide, goToSlide }) => {
          if (this.props.isBottomControlsEnabled) {
            let numOfSlides = new Array(slideCount).fill('slide')
            return (
              <div>
                {numOfSlides.map((_, paddingDotIndex) => (
                  <div
                    key={paddingDotIndex}
                    onClick={() => goToSlide(paddingDotIndex)}
                    className={`${paddingDot} ${paddingDotIndex === currentSlide ? 'active' : ''}`}
                  />
                ))}
              </div>
            )
          }
          return <div />
        }}
        renderCenterLeftControls={({ previousSlide, currentSlide }) => {
          if (this.props.isPrevIconDisabled) {
            return false
          } else {
            return (
              <>
                {/* && !isMobile && <LeftMasking isIpad={isIpad} />} */}
                <LazyLoad>
                  <button
                    onClick={previousSlide}
                    className={
                      this.props.chevronIndicator
                        ? `${arrowButtons} default`
                        : this.props.transitionMode === 'scroll3d'
                        ? `${hiddenButtons} slider-hidden-button`
                        : currentSlide === 0
                        ? destroyButtons
                        : `${arrowButtons} default`
                    }
                  >
                    {isDefaultChevron && <span className={chevronLeft} />}
                    {this.props.transitionMode === 'scroll3d' && (
                      <div className={`${arrowWrapperLeft} arrowWrapper`}>
                        <span className={chevronLeft} />
                      </div>
                    )}
                  </button>
                </LazyLoad>
              </>
            )
          }
        }}
        renderCenterRightControls={({ nextSlide, slideCount, currentSlide }) => {
          const newVal = slideCount - (this.props.slidesToShow || 1)
          if (this.props.isNextIconDisabled) {
            return false
          } else {
            return (
              <LazyLoad>
                <button
                  onClick={nextSlide}
                  className={
                    this.props.chevronIndicator
                      ? `${arrowButtons} default`
                      : this.props.transitionMode === 'scroll3d'
                      ? `${hiddenButtons} slider-hidden-button`
                      : currentSlide === newVal
                      ? destroyButtons
                      : `${arrowButtons} default`
                  }
                >
                  {isDefaultChevron && <span className={chevronRight} />}
                  {this.props.transitionMode === 'scroll3d' && (
                    <div className={`${arrowWrapperRight} arrowWrapper`}>
                      <span className={chevronRight} />
                    </div>
                  )}
                </button>
              </LazyLoad>
            )
          }
        }}
      >
        {this.props.children}
      </Carousel>
    )
  }
}

BannerCarousel.defaultProps = {
  hasChevronIndicator: true,
}

export default BannerCarousel
